import {Card, Col, Tag, Typography} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Link} from "react-router-dom";
import React from "react";
import {useUser} from "../hooks/user.hook";
import {tokens} from "./ui/tokens";

const COMPANY_LABEL = {roche: 'Roche', j: 'Johnson & Johnson'}

/**
 * Карточка модели на главной. Видимость по-прежнему зависит от префикса
 * имени пользователя: admin видит все, остальные — только карточки своей
 * компании (см. company).
 */
export const MainPageCard = ({title, description, span, icon, link, height, img, company}) => {
    const user = useUser()

    const userType = (user.username || '').split('_')[0]
    if ((userType !== 'admin') && (userType !== company))
        return <></>

    const cover = img
        ? `${process.env.PUBLIC_URL}/images/img/${img}`
        : "https://gw.alipayobjects.com/zos/rmsportal/JiqGstEfoWAOHiTxclqi.png"

    return <Col xs={24} sm={12} xl={span || 6}>
        <Link to={link || '/'}>
            <Card
                hoverable
                bordered={false}
                className={"model-card"}
                style={{borderRadius: tokens.radius, overflow: 'hidden', boxShadow: tokens.shadow, height: '100%'}}
                bodyStyle={{padding: 16}}
                cover={<div className={"model-card__cover"}>
                    <img alt={title} src={cover}/>
                    {COMPANY_LABEL[company] &&
                        <Tag className={"model-card__tag"}>{COMPANY_LABEL[company]}</Tag>}
                </div>}
            >
                <div style={{display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6}}>
                    {icon && <span className={"model-card__icon"}><FontAwesomeIcon icon={icon}/></span>}
                    <Typography.Title level={5} style={{margin: 0, fontWeight: 600}}>{title}</Typography.Title>
                </div>
                <Typography.Paragraph type={"secondary"} style={{margin: 0, fontSize: 13}}
                                      ellipsis={{rows: 3}}>
                    {description}
                </Typography.Paragraph>
            </Card>
        </Link>
    </Col>
}
